var exports = {
  "M": "ProfileGradient.module__surface___aEFKbU",
};

module.exports = exports;
